var map = {
	"./de/Abb17-Bodenversiegelung-Transp-Abfluss-Muc-Wzbg.png": 61444,
	"./en/Abb17-Bodenversiegelung-Transp-Abfluss-Muc-Wzbg.png": 36765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75618;